var React = require('react');
var WatchFaceModule = require('WatchFace/WatchFaceModule');

// Assets
var iwcDark = require('images/iwc_logo-dark.svg');
var iwcLight = require('images/iwc_logo.svg');
var spursDark = require('images/spurs_logo.svg');
var spursLight = require('images/logo.svg');

require('./IWCBanner.scss');

class IWCBanner extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			defaultMParticleEventObject: (typeof window !== "undefined") ? window.defaultMParticleEventObject : null
		}
	}

	handleClick(event) {

		const shouldTrackWithMParticle = this.state.defaultMParticleEventObject !== null;

		if (shouldTrackWithMParticle) {

			const eventData = {
				event: 'promo_selected',
				placement_name: 'promotion',
				placement_type: 'banner',
				campaign_name: (this.props.data.campaignName !== undefined) ? this.props.data.campaignName : '',
				promotion_name: (this.props.data.promotionName !== undefined) ? this.props.data.promotionName : '',
				promotion_partner: (this.props.data.promotionPartner !== undefined) ? this.props.data.promotionPartner : '',
				promotion_variant: (this.props.data.promotionVariant !== undefined) ? this.props.data.promotionVariant : ''
			};

			const eventDataMerged = {...this.state.defaultMParticleEventObject, ...eventData };
			window.dataLayer.push(eventDataMerged);

		}

	}

	render() {
		return (
			<a className={"IWCBanner " + this.props.data.colour} href={this.props.data.targetUrl.url} rel="noopener noreferrer" target="_blank" onClick={this.handleClick.bind(this)}>
				<h1 className="IWCBanner__title">{this.props.data.title}</h1>
				<WatchFaceModule />
				<div className="IWCBanner__imgs">
					<div className="IWCBanner__img crest">
						<img src={this.props.data.light ? spursDark : spursLight} alt="" />
					</div>
					<div className="IWCBanner__img iwc">
						<img src={this.props.data.light ? iwcDark : iwcLight} alt="" />
					</div>
				</div>
			</a>
		)
	}
}

module.exports = IWCBanner;



// WEBPACK FOOTER //
// ./src/components/IWCBanner/IWCBannerModule.js